// The deliberate sign-out, provided by AuthGate and used by the account menu. AuthGate owns what
// signing out MEANS (forget the remembered address, then sign out); the shell only offers it.
// Null outside AuthGate — the local preview — where the menu leaves the item out.

import { createContext, useContext } from "react";

export const SignOutContext = createContext<(() => void) | null>(null);

export function useSignOut(): (() => void) | null {
  return useContext(SignOutContext);
}
